module.exports = __webpack_public_path__ + "img/menu_shuzhiren.382a3a6c.png";